module.exports = __webpack_public_path__ + "img/edge_nature_plage.77f04d8e.svg";